import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await fetch(`${API_URL}/auth/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password })
      });

      if (!response.ok) {
        throw new Error('Invalid admin credentials');
      }

      const data = await response.json().catch(() => ({}));

      if (data.token) {
        localStorage.setItem('adminToken', data.token);
      }

      navigate('/admin', { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-[#151515] border border-white/10 rounded-2xl p-8 shadow-xl">
        <h1 className="text-2xl font-semibold text-white mb-6" style={{ fontFamily: 'Lexend, sans-serif' }}>
          Admin Login
        </h1>

        {error && (
          <div className="mb-4 p-3 rounded-lg bg-red-500/10 border border-red-500/40 text-red-300 text-sm">
            {error}
          </div>
        )}

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="block text-sm text-gray-300 mb-2">Username</label>
            <input
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 rounded-lg bg-[#0F0F0F] border border-white/10 text-white focus:outline-none focus:border-[#676DFF]"
              placeholder="e.g. admin"
              required
            />
          </div>

          <div>
            <label className="block text-sm text-gray-300 mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-lg bg-[#0F0F0F] border border-white/10 text-white focus:outline-none focus:border-[#676DFF]"
              required
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full py-3 rounded-lg bg-[#676DFF] hover:bg-[#5A60E8] disabled:opacity-60 text-white font-semibold transition-colors"
            style={{ fontFamily: 'Lexend, sans-serif' }}
          >
            {isSubmitting ? 'Signing in...' : 'Sign in'}
          </button>

          <div className="text-center pt-2">
            <Link
              to="/admin/forgot-password"
              className="text-sm text-gray-400 hover:text-[#676DFF] transition-colors"
              style={{ fontFamily: 'Lexend, sans-serif' }}
            >
              Forgot password?
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;


